import { httpClient } from "api/httpClient";
import React from "react";
import { useNotifyError } from "utils/notifiers/useNotifyError";

export const labelLogoUrl = (terminalId) => `/terminal/${terminalId}/label-logo`;

export const useTerminalLabelLogo = (terminalId) => {
	const [labelLogo, setLabelLogo] = React.useState(null);
	const [isLoading, setIsLoading] = React.useState(true);

	const notifyError = useNotifyError();

	React.useEffect(() => {
		let isCurrent = true;

		setIsLoading(true);
		httpClient(labelLogoUrl(terminalId))
			.then(({ json }) => {
				if (isCurrent) setLabelLogo(json);
			})
			.catch((error) => {
				if (isCurrent) notifyError(error);
			})
			.finally(() => {
				if (isCurrent) setIsLoading(false);
			});

		return () => {
			isCurrent = false;
		};
	}, [terminalId, notifyError]);

	return { labelLogo, setLabelLogo, isLoading };
};
